<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add an 'As a service' Offering:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    
                    <v-textarea 
                    outline 
                    :label="nameofaasofferingLabeltext" 
                    v-model="nameofaasoffering" 
                    :hint="nameofaasofferingHint" 
                    :rules="textInputRules"></v-textarea>

                     <v-textarea 
                    outline 
                    :label="descriptionofaasofferingLabeltext" 
                    v-model="descriptionofaasoffering" 
                    :hint="descriptionofaasofferingHint" 
                    :rules="textInputRules"></v-textarea>

                    <v-select
                        v-model="aasofferingtypedefault"
                        :items="aasofferingtypes"
                        :label="aasofferingtypesLabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>

                    <v-textarea 
                    outline 
                    :label="parentcompanyofaasofferingLabeltext" 
                    v-model="parentcompanyofaasoffering" 
                    :hint="parentcompanyofaasofferingHint" 
                    :rules="textInputRules"></v-textarea>


                    <v-textarea 
                    outline 
                    :label="taskcorrespondingtotheaasofferingLabeltext" 
                    v-model="taskcorrespondingtotheaasoffering" 
                    :hint="taskcorrespondingtotheaasofferingHint" 
                    :rules="textInputRules"></v-textarea>

                    <v-select
                        v-model="aasofferingpercentagebenefitdefault"
                        :items="aasofferingpercentagebenefitrange"
                        :label="aasofferingpercentagebenefitLabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>

                    <!-- <v-checkbox v-model="featureavailableinacompetingproduct" :label="featureavailableinacompetingproductLabeltext"></v-checkbox>  -->

                    
                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Detail</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Offering</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            nameofaasoffering: 'Google Apps suite',
            nameofaasofferingLabeltext: 'Please provide the name of the service',
            nameofaasofferingHint: '',
            descriptionofaasoffering: 'An application suite for team productivity',
            descriptionofaasofferingLabeltext: 'Please provide a description for the service',
            descriptionofaasofferingHint: '',
            parentcompanyofaasoffering: 'Google LLC',
            parentcompanyofaasofferingLabeltext: 'Please provide the parent company for this service',
            parentcompanyofaasofferingHint: '',
            taskcorrespondingtotheaasoffering: 'Collaboration when working on joint tasks',
            taskcorrespondingtotheaasofferingLabeltext: 'Which task does this service assist with?',
            taskcorrespondingtotheaasofferingHint: '',


            aasofferingtypedefault: 'Software as a Service',
            aasofferingtypes: ['Software as a Service', 'Rapid application development framework', 'Third party framework'],
            aasofferingtypesLabelText: 'Please provide the type of service',

            aasofferingpercentagebenefitdefault: '5%',
            aasofferingpercentagebenefitrange: ['5%', '10%', '15%','20%', '25%', '30%','35%', '40%', '45%','50%', '55%', '60%','65%','70%', '75%', '80%','85%', '90%', '95%','100%'],
            aasofferingpercentagebenefitLabelText: 'Please Approx. percentage of time saved as a result of service usage',
            
           
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const aasservice = {
                nameofaasoffering: this.nameofaasoffering,
                descriptionofaasoffering: this.descriptionofaasoffering,
                parentcompanyofaasoffering: this.parentcompanyofaasoffering,
                aasofferingtype: this.aasofferingtypedefault,
                taskcorrespondingtotheaasoffering: this.taskcorrespondingtotheaasoffering,
		aasofferingpercentagebenefitdefault: this.aasofferingpercentagebenefitdefault
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('aasofferings');

        dbref.add(aasservice).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('serviceadded')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
